import { useMemo } from 'react';
import { GridView } from '../../preload/pages/CategoryPage/Providers/ViewSettingsProvider';
import { IPicture } from '../../styled/Image';
import { formatImage } from '../../utils/image';
import { IImage } from '.';

const resolveProductImage = (view: GridView, image: string): IPicture => {
  if (view === 'grid-large') {
    return {
      image: {
        src: formatImage(image, { width: 520, height: 578, cdn: true }),
      },
      sources: [
        {
          type: 'image/webp',
          media: '(max-width: 599px)',
          srcSet: `
          ${formatImage(image, { width: 504, height: 558, output: 'webp', cdn: true, usm: 15, quality: 90 })} 504w,
          ${formatImage(image, { width: 806, height: 893, output: 'webp', cdn: true, usm: 15, quality: 90 })} 806w
        `,
        },
        {
          type: 'image/webp',
          media: '(max-width: 899px)',
          srcSet: `
          ${formatImage(image, { width: 406, height: 436, output: 'webp', cdn: true, usm: 15, quality: 90 })} 406w,
          ${formatImage(image, { width: 650, height: 698, output: 'webp', cdn: true, usm: 15, quality: 90 })} 650w
        `,
        },
        {
          type: 'image/webp',
          media: '(max-width: 1199px)',
          srcSet: `
          ${formatImage(image, { width: 520, height: 578, output: 'webp', cdn: true, usm: 15, quality: 90 })} 399w,
          ${formatImage(image, { width: 832, height: 924, output: 'webp', cdn: true, usm: 15, quality: 90 })} 832w
        `,
        },
        {
          type: 'image/webp',
          media: '(min-width: 1200px)',
          srcSet: `
          ${formatImage(image, { width: 399, height: 426, output: 'webp', cdn: true, usm: 15, quality: 90 })} 399w,
          ${formatImage(image, { width: 638, height: 681, output: 'webp', cdn: true, usm: 15, quality: 90 })} 638w
        `,
        },
      ],
    };
  }
  return {
    image: {
      src: formatImage(image, { width: 330, height: 341, cdn: true }),
    },
    sources: [
      {
        type: 'image/webp',
        media: '(max-width: 599px)',
        srcSet: `
        ${formatImage(image, { width: 256, height: 248, output: 'webp', cdn: true, usm: 15, quality: 90 })} 256w,
        ${formatImage(image, { width: 413, height: 397, output: 'webp', cdn: true, usm: 15, quality: 90 })} 413w
      `,
      },
      {
        type: 'image/webp',
        media: '(max-width: 899px)',
        srcSet: `
        ${formatImage(image, { width: 258, height: 250, output: 'webp', cdn: true, usm: 15, quality: 90 })} 258w,
        ${formatImage(image, { width: 410, height: 400, output: 'webp', cdn: true, usm: 15, quality: 90 })} 410w
      `,
      },
      {
        type: 'image/webp',
        media: '(max-width: 1199px)',
        srcSet: `
        ${formatImage(image, { width: 330, height: 341, output: 'webp', cdn: true, usm: 15, quality: 90 })} 330w,
        ${formatImage(image, { width: 528, height: 546, output: 'webp', cdn: true, usm: 15, quality: 90 })} 528w
      `,
      },
      {
        type: 'image/webp',
        media: '(min-width: 1200px)',
        srcSet: `
        ${formatImage(image, { width: 285, height: 284, output: 'webp', cdn: true, usm: 15, quality: 90 })} 285w,
        ${formatImage(image, { width: 456, height: 454, output: 'webp', cdn: true, usm: 15, quality: 90 })} 456w
      `,
      },
    ],
  };
};

const resolveContextualImage = (view: GridView, image?: string): IPicture | undefined => {
  if (!image) {
    return undefined;
  }

  if (view === 'grid-large') {
    return {
      image: {
        src: formatImage(image, { width: 552, height: 690, crop: true, cdn: true }),
      },
      sources: [
        {
          type: 'image/webp',
          media: '(max-width: 599px)',
          srcSet: `
          ${formatImage(image, { width: 536, height: 670, output: 'webp', cdn: true, crop: true, usm: 15, quality: 90 })} 536w,
          ${formatImage(image, { width: 858, height: 1072, output: 'webp', cdn: true, crop: true, usm: 15, quality: 90 })} 858w
        `,
        },
        {
          type: 'image/webp',
          media: '(max-width: 899px)',
          srcSet: `
          ${formatImage(image, { width: 438, height: 548, output: 'webp', cdn: true, crop: true, usm: 15, quality: 90 })} 438w,
          ${formatImage(image, { width: 700, height: 876, output: 'webp', cdn: true, crop: true, usm: 15, quality: 90 })} 700w
        `,
        },
        {
          type: 'image/webp',
          media: '(max-width: 1199px)',
          srcSet: `
          ${formatImage(image, { width: 552, height: 690, output: 'webp', cdn: true, crop: true, usm: 15, quality: 90 })} 552w,
          ${formatImage(image, { width: 883, height: 1104, output: 'webp', cdn: true, crop: true, usm: 15, quality: 90 })} 883w
        `,
        },
        {
          type: 'image/webp',
          media: '(min-width: 1200px)',
          srcSet: `
          ${formatImage(image, { width: 431, height: 538, output: 'webp', cdn: true, crop: true, usm: 15, quality: 90 })} 431w,
          ${formatImage(image, { width: 690, height: 860, output: 'webp', cdn: true, crop: true, usm: 15, quality: 90 })} 690w
        `,
        },
      ],
    };
  }
  return {
    image: {
      src: formatImage(image, { width: 363, height: 453, cdn: true, crop: true }),
    },
    sources: [
      {
        type: 'image/webp',
        media: '(max-width: 599px)',
        srcSet: `
        ${formatImage(image, { width: 288, height: 360, output: 'webp', cdn: true, crop: true, usm: 15, quality: 90 })} 288w,
        ${formatImage(image, { width: 460, height: 576, output: 'webp', cdn: true, crop: true, usm: 15, quality: 90 })} 460w
      `,
      },
      {
        type: 'image/webp',
        media: '(max-width: 899px)',
        srcSet: `
        ${formatImage(image, { width: 289, height: 362, output: 'webp', cdn: true, crop: true, usm: 15, quality: 90 })} 289w,
        ${formatImage(image, { width: 460, height: 576, output: 'webp', cdn: true, crop: true, usm: 15, quality: 90 })} 460w
      `,
      },
      {
        type: 'image/webp',
        media: '(max-width: 1199px)',
        srcSet: `
        ${formatImage(image, { width: 363, height: 453, output: 'webp', cdn: true, crop: true, usm: 15, quality: 90 })} 363w,
        ${formatImage(image, { width: 580, height: 725, output: 'webp', cdn: true, crop: true, usm: 15, quality: 90 })} 580w
      `,
      },
      {
        type: 'image/webp',
        media: '(min-width: 1200px)',
        srcSet: `
        ${formatImage(image, { width: 317, height: 396, output: 'webp', cdn: true, crop: true, usm: 15, quality: 90 })} 317w,
        ${formatImage(image, { width: 507, height: 634, output: 'webp', cdn: true, crop: true, usm: 15, quality: 90 })} 507w
      `,
      },
    ],
  };
};

export const useProductCardImages = (productView: GridView, images: IImage[]) => {
  const image = useMemo(
    () => resolveProductImage(productView, images[0].url),
    [images, productView],
  );

  const contextualImage = useMemo(
    () =>
      resolveContextualImage(
        productView,
        images.find((i) => i.mediaType === 'Produktbild miljö')?.url,
      ),
    [images, productView],
  );

  return {
    image,
    contextualImage,
  };
};
